import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

function isMobile() {
	const userAgent = navigator.userAgent || navigator.vendor || window.opera;
	// 这里使用正则表达式匹配常见的移动设备用户代理
	let isMobile = /android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase());
	return isMobile;
}

function getQueryVariable(variable) {
	var query = window.location.search.substring(1);
	var vars = query.split("&");
	for (var i = 0; i < vars.length; i++) {
		var pair = vars[i].split("=");
		if (pair[0] == variable) { return pair[1]; }
	}
	return (false);
}
let region = decodeURIComponent(getQueryVariable("area"));
let title = decodeURIComponent(getQueryVariable("title"));
let orgId = decodeURIComponent(getQueryVariable("orgId"));
let orgCode = decodeURIComponent(getQueryVariable("orgCode"));
let sign = decodeURIComponent(getQueryVariable("sign"));
let buildIds = decodeURIComponent(getQueryVariable("buildIds"));
if (buildIds == 'false') {
	buildIds = '';
}

let storage = window.localStorage;
storage.clear();
storage.setItem('region', region);
storage.setItem('title', title);
storage.setItem('orgId', orgId);
storage.setItem('orgCode', orgCode);
storage.setItem('sign', sign);
storage.setItem('buildIds', buildIds);

let routes = [
	//其他
	{ path: '/dataView/gate', name: 'gate_index', component: () => import('../other/gate/index.vue') },
	{ path: '/dataView/gate/school', name: 'gate_school_index', component: () => import('../other/gate/index.vue') },
	{ path: '/dataView/temp', name: 'temp_index', component: () => import('../other/temp/index.vue') },
	{ path: '/dataView/temp/school', name: 'temp_school_index', component: () => import('../other/temp/index.vue') },
	{ path: '/dataView/pay', name: 'pay_index', component: () => import('../other/pay/index.vue') },
	{ path: '/dataView/headmaster/school', name: 'pay_school_index', component: () => import('../other/headmaster/index.vue') },
	//学校端
	{ path: '/dataView/appIndex/school', name: 'appIndex_org_index', component: () => import('../views/index/orgIndex.vue') },
	{ path: '/dataView/area/school', name: 'area_org_index', component: () => import('../views/areaOrg/index.vue') },
	{ path: '/dataView/quality/school', name: 'quality_org_index', component: () => import('../views/qualityOrg/index.vue') },
	{ path: '/dataView/clubClass/school', name: 'clubClass_org_index', component: () => import('../views/clubClassOrg/index.vue') },
	{ path: '/dataView/threeClass/school', name: 'threeClass_org_index', component: () => import('../views/threeClass/school_index.vue') },
	{ path: '/dataView/security/school', name: 'security_org_index', component: () => import('../views/security/school_index.vue') },
	{ path: '/dataView/dorm/school', name: 'dorm_org_index', component: () => import('../views/dorm/index.vue') },
	//教育局端
	{ path: '/dataView/login', name: 'appIndex_edu_login', component: () => import('../views/index/login.vue') },
	{ path: '/dataView/appIndex', name: 'appIndex_edu_index', component: () => import('../views/index/eduIndex.vue') },
	{ path: '/dataView/area', name: 'area_edu_index', component: () => import('../views/areaEdu/index.vue') },
	{ path: '/dataView/quality', name: 'quality_edu_index', component: () => import('../views/qualityEdu/index.vue') },
	{ path: '/dataView/clubClass', name: 'clubClass_edu_index', component: () => import('../views/clubClassEdu/index.vue') },
	{ path: '/dataView/threeClass', name: 'threeClass_edu_index', component: () => import('../views/threeClass/edu_index.vue') },
	{ path: '/dataView/security', name: 'security_edu_index', component: () => import('../views/security/edu_index.vue') },
]
if (isMobile()) {
	routes = [
		//其他
		{ path: '/dataView/gate', name: 'gate_index', component: () => import('../other/gate/index.vue') },
		{ path: '/dataView/gate/school', name: 'gate_school_index', component: () => import('../other/gate/index.vue') },
		{ path: '/dataView/temp', name: 'temp_index', component: () => import('../other/temp/index.vue') },
		{ path: '/dataView/temp/school', name: 'temp_school_index', component: () => import('../other/temp/index.vue') },
		{ path: '/dataView/pay', name: 'pay_index', component: () => import('../other/pay_phone/index.vue') },
		{ path: '/dataView/headmaster/school', name: 'pay_school_index', component: () => import('../other/headmaster/index.vue') },
		//学校端
		{ path: '/dataView/appIndex/school', name: 'appIndex_org_index', component: () => import('../views/index/orgIndex.vue') },
		{ path: '/dataView/area/school', name: 'area_org_index', component: () => import('../views/areaOrg/index.vue') },
		{ path: '/dataView/quality/school', name: 'quality_org_index', component: () => import('../views/qualityOrg/index.vue') },
		{ path: '/dataView/clubClass/school', name: 'clubClass_org_index', component: () => import('../views/clubClassOrg/index.vue') },
		{ path: '/dataView/threeClass/school', name: 'threeClass_org_index', component: () => import('../views/threeClass/school_index.vue') },
		{ path: '/dataView/security/school', name: 'security_org_index', component: () => import('../views/security/school_index.vue') },
		{ path: '/dataView/dorm/school', name: 'dorm_org_index', component: () => import('../views/dorm/index.vue') },
		//教育局端
		{ path: '/dataView/login', name: 'appIndex_edu_login', component: () => import('../views/index/login.vue') },
		{ path: '/dataView/appIndex', name: 'appIndex_edu_index', component: () => import('../views/index/eduIndex.vue') },
		{ path: '/dataView/area', name: 'area_edu_index', component: () => import('../views/areaEdu/index.vue') },
		{ path: '/dataView/quality', name: 'quality_edu_index', component: () => import('../views/qualityEdu/index.vue') },
		{ path: '/dataView/clubClass', name: 'clubClass_edu_index', component: () => import('../views/clubClassEdu/index.vue') },
		{ path: '/dataView/threeClass', name: 'threeClass_edu_index', component: () => import('../views/threeClass/edu_index.vue') },
		{ path: '/dataView/security', name: 'security_edu_index', component: () => import('../views/security/edu_index.vue') },
	]
}


//线上模式：hash，调试模式：history
const router = new VueRouter({
	mode: "hash",
	routes
})
export default router